import { Component } from '@angular/core';

/**
 * Statement Production Guide — full how-to walkthrough for new staff.
 * Linked from the top-right of /owner-statements.
 * Standalone page so users can have it open in a second tab while working.
 */
@Component({
  selector: 'app-statement-production-guide',
  templateUrl: './statement-production-guide.component.html',
  styleUrls: ['./statement-production-guide.component.scss'],
  standalone: false
})
export class StatementProductionGuideComponent {
  printGuide() {
    window.print();
  }

  scrollTo(id: string) {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
